/**
 * Converts a blob to base64 string
 * @param {Blob} blob - Image blob
 * @returns {Promise<string>} - Base64 encoded string
 */
export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

/**
 * Converts a blob to data URL for preview
 * @param {Blob} blob - Image blob
 * @returns {string} - Object URL
 */
export const blobToObjectURL = (blob) => {
  return URL.createObjectURL(blob);
};

export const fetchImageBlob = async (imageUrl) => {
  const fetchOptions = {
    mode: 'cors',
    credentials: 'omit',
  };
  let response;
  try {
    response = await fetch(imageUrl, fetchOptions);
  } catch {
    response = await fetch(imageUrl, {
      ...fetchOptions,
      cache: 'reload',
    });
  }
  if (!response.ok) {
    throw new Error(`Image request failed with status ${response.status}`);
  }
  return response.blob();
};
